import React, { useState } from "react";
import BasicDetailsUser from "./BasicDetailsUser";
import SelectManagement from "./SelectManagement";

function OnboardUserIndex({ onClose }) {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  return (
    <div>
      {step === 0 ? (
        <BasicDetailsUser
          onClickNext={(data) => {
            setStep(1);
            setData(data);
          }}
          onClickBack={onClose}
        />
      ) : (
        <SelectManagement
          data={data}
          onSuccess={onClose}
          onClickCancel={() => {
            onClose();
          }}
        />
      )}
    </div>
  );
}

export default OnboardUserIndex;
